<!-- components/property_detail/PropertyVideo.vue -->
<template>
  <div v-if="videoUrl" class="video-wrapper mb-4">
    <div v-if="videoType === 'youtube' || videoType === 'vimeo'">
      <div ref="plyrContainer" class="plyr__video-embed" :data-plyr-provider="videoType" :data-plyr-embed-id="embedId"></div>
    </div>
    <video v-else ref="videoRef" class="plyr" controls playsinline>
      <source :src="videoUrl" type="video/mp4" />
    </video>
  </div>
</template>

<script setup>
import { onMounted, ref, computed } from 'vue'
import Plyr from 'plyr'
import 'plyr/dist/plyr.css'

const props = defineProps({ videoUrl: String })

const videoRef = ref(null)
const plyrContainer = ref(null)

const videoType = computed(() => {
  if (/youtu\.be|youtube\.com/.test(props.videoUrl)) return 'youtube'
  if (/vimeo\.com/.test(props.videoUrl)) return 'vimeo'
  if (props.videoUrl.endsWith('.mp4')) return 'mp4'
  return 'unknown'
})

const embedId = computed(() => {
  if (videoType.value === 'youtube') {
    const match = props.videoUrl.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&]+)/)
    return match?.[1] || ''
  } else if (videoType.value === 'vimeo') {
    const match = props.videoUrl.match(/vimeo\.com\/(\d+)/)
    return match?.[1] || ''
  }
  return ''
})

onMounted(() => {
  if (videoType.value === 'mp4' && videoRef.value) {
    new Plyr(videoRef.value)
  } else if ((videoType.value === 'youtube' || videoType.value === 'vimeo') && plyrContainer.value) {
    new Plyr(plyrContainer.value)
  }
})
</script>

<style scoped>
.video-wrapper {
  max-width: 100%;
}
</style>
